import React, { Component }  from 'react';
import Toolbar from '../GanttChart/Toolbar';
import Gantt from '../GanttChart/Gantt';
import { MenuItem, Grid, Menu, Fab } from '@material-ui/core';
import ListIcon from '@material-ui/icons/List';
import { toast } from 'react-toastify';
import { GETEXPORTPLANNING } from '../../constants/Config';
import { useTranslation, Trans } from 'react-i18next';
const { t } = useTranslation();

class PlanningIndexPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentZoom: "2",
            anchorEl: null
        };
    }
    componentDidMount() {
        this.props.setHeader();
    };

    handleZoomChange = (zoom) => {
        this.setState({
          currentZoom: zoom
        });
      }

    refreshGantt = () => {

    }

    handleClick = event => {
        this.setState({ anchorEl: event.currentTarget });
    };
    
    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    exportToExcel() {
        fetch(GETEXPORTPLANNING + this.props.startDate + '/' + this.props.endDate, {method: 'GET'})
        .then((response) => {
            return response.text().then(text => {
                const data = text && JSON.parse(text);
                if (!response.ok) {
                    const error = (data && data.message) || response.statusText;
                    toast.error(error, {
                        position: toast.POSITION.TOP_CENTER
                      });
                    return Promise.reject(error);
                }

                return data;
            });
        })
        .then((res) => {
            if(res.succeeded === false) {
                for (let index = 0; index < res.messages.length; index++) {
                    toast.error(res.messages[index], {
                        position: toast.POSITION.TOP_CENTER
                      });
                }
                return Promise.reject();
            }
            toast.info(<Trans>{t('exportToExcelSucceeded')}</Trans>, {
                position: toast.POSITION.TOP_CENTER
              })
            this.setState({ anchorEl: null });
        })
        .catch(function(error) {
            toast.error(error, {
                position: toast.POSITION.TOP_CENTER
              });
        });
    }

    render() {
        const { currentZoom, anchorEl } = this.state;
        return (
            <React.Fragment>
                <Toolbar
                    zoom={currentZoom}
                    onZoomChange={this.handleZoomChange}
                    setPlanningSearchDates={this.props.setPlanningSearchDates}
                    startDate={this.props.startDate} endDate={this.props.endDate}
                    refreshGantt = {this.refreshGantt}
                />
                <Gantt startDate={this.props.startDate} endDate={this.props.endDate} zoom={currentZoom} setPlanningSearchDates={this.props.setPlanningSearchDates}></Gantt>
                <Grid container spacing={0}>
                    <Grid item xs={1}>
                        <Fab color="primary" aria-owns={anchorEl ? 'simple-menu' : undefined}
                            aria-haspopup="true"
                            onClick={this.handleClick}
                            className="ActionButton">
                            <ListIcon></ListIcon>
                        </Fab>
                        <Menu id="simple-menu" anchorEl={anchorEl} getContentAnchorEl={null}
                            anchorOrigin={{
                              vertical: 'top',
                              horizontal: 'center',
                            }}
                            transformOrigin={{
                              vertical: 'bottom',
                              horizontal: 'center',
                            }}
                            open={Boolean(anchorEl)}
                            onClose={this.handleClose}>
                            <MenuItem onClick={() => this.exportToExcel()}><Trans>{t('exportToExcel')}</Trans></MenuItem>
                        </Menu>
                    </Grid>
                </Grid>
            </React.Fragment>
        )
    }
}

export default PlanningIndexPage;